import React from "react"
import MoreInfo from "../MoreInfo/MoreInfo"
import styled from "styled-components/macro"
import {
  EmailShareButton,
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailIcon,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
} from "react-share"

const SocialShare = styled.section`
  margin-top: 20px;
  align-self: flex-start;
  .MoreInfo-styles {
    align-items: flex-start;
  }
  .MoreInfo-content {
    flex-direction: row;
  }
  .react-share__ShareButton {
    margin-right: 10px;
    height: 50px;
    &:last-child {
      margin-right: 0;
    }
    @media screen and (min-width: 790px) {
      margin-right: 20px;
    }
  }
`

const ArticleShare = ({ id, shareUrl }) => {
  return (
    <SocialShare id={id} role="region">
      <MoreInfo title="Share">
        <FacebookShareButton url={shareUrl}>
          <FacebookIcon size={50} round={false} />
        </FacebookShareButton>

        <TwitterShareButton url={shareUrl}>
          <TwitterIcon size={50} round={false} />
        </TwitterShareButton>

        <WhatsappShareButton url={shareUrl}>
          <WhatsappIcon size={50} round={false} />
        </WhatsappShareButton>

        <EmailShareButton url={shareUrl}>
          <EmailIcon size={50} round={false} />
        </EmailShareButton>
      </MoreInfo>
    </SocialShare>
  )
}

export default ArticleShare
